// extracted by mini-css-extract-plugin
export default {"registr_container":"registr_registr_container__ql8hL","input_group":"registr_input_group__d7JaJ"};